import Swiper from './lib/swiper-bundle.min';

export default () => {
  document.addEventListener("DOMContentLoaded", function () {
    const $swiperElement = document.getElementById('swiper-room');
    if (!$swiperElement) return;

    //let $swiperParameter = new Swiper(".swiper-support-thumbnail", {
    let $swiperParameter = {
      loop: true,
      clickable:true,
      centeredSlides: true,
      slidesPerView: 'auto',
      preventClicksPropagation:true,
      //spaceBetween: 32,
      threshold:20,
      preventClicks: true,
      speed: 200,
      navigation: {
        nextEl: ".swiper-room-button-next",
        prevEl: ".swiper-room-button-prev",
      },
      thumbs: {
        //swiper: sliderThumbnail,
      },
      on: {

        init: function(){
// 任意の処理を実行
        },
        slideChange: function(){
          const listItems = document.querySelectorAll(".swiper-slide-room");

          listItems.forEach((li,index) => {
            li.addEventListener('click',() => {
              let url = li.dataset.url;
              // 対応するクラス要素を取得
              const targetEl = document.querySelector(`.${url}`);
              if (targetEl) {
                // いったん全部非表示にする場合（任意）
                document.querySelectorAll('.room_wrap').forEach(el => {
                  el.style.display = 'none';
                });
                // 対象を表示
                targetEl.style.display = 'block';
              }
              let $swiperElement2 = document.getElementById('modal_wrap');
              $swiperElement2.classList.add('js-modal-open');
            })
          });
        },
      }
    };

   const roomswiper = new Swiper($swiperElement, $swiperParameter);
  });
}
